import moment, { Moment } from "moment";

export const formatDate = (
  date?: string | Date,
  format: string = "DD MMMM, YYYY"
) => {
  return moment(date || new Date()).format(format);
};

export const formatTime = (
  date?: string | Date,
  format: string = "h:mm:ss A"
) => {
  return moment(date || new Date()).format(format);
};

export const formatTo12Hour = (timeString: string) => {
  if (!timeString) return "N/A";

  // remove any existing AM/PM if accidentally present
  const cleanTime = timeString.replace(/ AM| PM/i, "");

  const [hours, minutes, seconds] = cleanTime.split(":").map(Number);
  if (isNaN(hours) || isNaN(minutes) || isNaN(seconds)) return timeString;

  const date = new Date();
  date.setHours(hours, minutes, seconds);

  return date.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  });
};

export const formatDateNotNew = (
  date?: string | Date,
  format: string = "DD MMMM, YYYY"
) => {
  if (!date || !moment(date).isValid()) return;
  return moment(date).format(format);
};

export const formatTimeNotNew = (
  date?: string | Date,
  format: string = "h:mm:ss A"
) => {
  if (!date || !moment(date).isValid()) return;
  return moment(date).format(format);
};

export const formatUTCTime = (date: string | Moment) => {
  // const dateData = new Date(date);

  // const UTCTime = new Date(
  //   dateData.getTime() - dateData.getTimezoneOffset() * 60000
  // );

  // return UTCTime.toISOString();
  // console.log(moment.utc(date).local().toISOString());

  return moment.utc(date).local().toISOString();
};

// calculate just minutes
export const calculateMinutes = (startTime: string, endTime: string) => {
  const start = moment(startTime, "h:mm A");
  const end = moment(endTime, "h:mm A");

  return end.diff(start, "minutes");
};

// calculate minute with date
export const calculateMinutesWithDate = (
  startTime: string,
  endTime: string
) => {
  const start = moment(startTime, "YYYY-MM-DDTH:mm A");
  const end = moment(endTime, "YYYY-MM-DDTH:mm A");

  return end.diff(start, "minutes");
};

export const minutesToHours = (minutes: number) => {
  const hours = Math.floor(minutes / 60);
  const minute = minutes % 60;
  return `${String(parseInt(hours?.toString())).padStart(2, "0")}:${String(
    parseInt(minute?.toString())
  ).padStart(2, "0")}`;
};

export const previousDate = (date: string, format: string = "YYYY-MM-DD") => {
  return moment(date, format).subtract(1, "days").format(format);
};

export const formattedPrice = (
  val: number | string | null | undefined
): string => {
  if (!val || isNaN(Number(val))) return "N/A";

  return new Intl.NumberFormat("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number(val));
};

export const numberToWords = (num: any) => {
  if (num === 0) return "Zero";

  const a = [
    "",
    "One",
    "Two",
    "Three",
    "Four",
    "Five",
    "Six",
    "Seven",
    "Eight",
    "Nine",
    "Ten",
    "Eleven",
    "Twelve",
    "Thirteen",
    "Fourteen",
    "Fifteen",
    "Sixteen",
    "Seventeen",
    "Eighteen",
    "Nineteen",
  ];

  const b = [
    "",
    "",
    "Twenty",
    "Thirty",
    "Forty",
    "Fifty",
    "Sixty",
    "Seventy",
    "Eighty",
    "Ninety",
  ];

  let words = "";

  const getBelowThousand = (n: any) => {
    let str = "";
    if (n >= 100) {
      str += a[Math.floor(n / 100)] + " Hundred ";
      n = n % 100;
    }
    if (n >= 20) {
      str += b[Math.floor(n / 10)] + " ";
      n = n % 10;
    }
    if (n > 0) {
      str += a[n] + " ";
    }
    return str.trim();
  };

  let crore = Math.floor(num / 10000000);
  if (crore > 0) {
    words += getBelowThousand(crore) + " Crore ";
    num = num % 10000000;
  }

  let lakh = Math.floor(num / 100000);
  if (lakh > 0) {
    words += getBelowThousand(lakh) + " Lakh ";
    num = num % 100000;
  }

  let thousand = Math.floor(num / 1000);
  if (thousand > 0) {
    words += getBelowThousand(thousand) + " Thousand ";
    num = num % 1000;
  }

  words += getBelowThousand(num);

  return words.trim();
};
